module.exports = __webpack_public_path__ + "static/danielgerth-logo-1ab4fc791e125ef86161e6276675daf5.png";